import { FormEvent, useContext } from "react";
import { MicrositeSearchContext } from "./context";
import { FormControl, Sizes } from "react-bootstrap";
import { IContact } from "@nkr/models/index";

interface IProps {
    value: number;
    defaultText: string;
    allowNone?: boolean;
    name?: string;
    title?: string;
    disabled?: boolean;
    bsSize?: Sizes,
    onChange: (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => void;
}

const CoachSelector = ({ value, onChange, defaultText, allowNone, name, title, disabled, bsSize }: IProps) => {
    const context = useContext(MicrositeSearchContext);

    const coaches = context.coachList?.filter(f => !f.isDeleted || f.id == value); //bring in deleted options if they're selected

    const options = coaches.sort((a, b) => a.fullName.localeCompare(b.fullName)).map((c: IContact, i: number) => {
        return (
            <option className={c.isDeleted ? 'option-deleted' : ''} key={`coach-` + i} value={c.id}>{c.fullName} ({c.currentCaseLoad}/{c.maxCaseLoad})</option>
        )
    });

    const selectedOptionDeleted: boolean | null = context.coachList?.find(f => f.id == value)?.isDeleted;

    const handleChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        const del = context.coachList?.find(f => f.id == parseInt(e.currentTarget.value))?.isDeleted;

        if (del || (!allowNone && parseInt(e.currentTarget.value) < 1)) {
            //dont change -- You're great the way you are.
        } else {
            onChange(e)
        }
    }

    return (<>
        <FormControl 
            className={`coach-drop ${selectedOptionDeleted ? 'option-deleted' : ''}`}
            bsSize={bsSize}
            componentClass='select'
            name={name}
            title={title}
            disabled={disabled}
            value={value}
            onChange={handleChange}
        >
            <option value={-1}>{defaultText}</option>
            {options}
        </FormControl>
    </>);
}

export default CoachSelector;

